// Homepage "Recently viewed" grid. Uses the shared browser-local history owner
// (recently-viewed.js) and stays hidden unless the header enables history, the
// visitor's privacy choice allows it, and there is history to show.
import { RecentlyViewedController } from 'folded-label/recently-viewed';

class HomeRecentlyViewed extends HTMLElement {
  connectedCallback() {
    const enabled = this.ownerDocument?.querySelector('fl-predictive-search[data-recently-viewed-enabled="true"]');
    if (!enabled || this.history) return;
    this.dataset.recentlyViewedEnabled = 'true';
    this.history = new RecentlyViewedController(this);
    this.history.connect();
  }

  disconnectedCallback() {
    this.history?.disconnect();
    this.history = null;
  }
}

if (!customElements.get('fl-home-recently-viewed')) customElements.define('fl-home-recently-viewed', HomeRecentlyViewed);
